import {Routes, Route, Navigate} from 'react-router-dom'
import React from "react"
import mainRoutes from "./mainRoutes"
import {useSelector} from "react-redux";
import {log} from "../utils/log";
import {canAccessSecgroup} from "../utils/permissions";


const  MainRouting = ( props ) => {
    const auth =  useSelector( (state) => state.auth);
    const isAuthenticated = auth.id !== null && typeof(auth.id) !== "undefined";
    const roleName = auth.roleName;

    // Find the first accessible route for the default redirect
    let defaultPath = "painel";
    if (isAuthenticated && roleName) {
        const canPainel = canAccessSecgroup(roleName, 90);
        if (!canPainel) {
            // Find first accessible non-noRoot route
            for (const r of mainRoutes) {
                if (r.type === "noRoot") continue;
                if (r.collapse && r.pages) {
                    const page = r.pages.find(p => p.type !== "noRoot" && canAccessSecgroup(roleName, p.secgroup));
                    if (page) { defaultPath = page.path; break; }
                } else if (canAccessSecgroup(roleName, r.secgroup)) {
                    defaultPath = r.path; break;
                }
            }
        }
    }

    let ixm = 0;
    log(2,"isAuth auth", auth.isAuthenticated, auth);

    return (
        <React.Fragment>
            <Routes>
                <Route index element={<Navigate to={defaultPath} replace />} />
        {
            mainRoutes.map( (r,ix) => {
                if (!isAuthenticated) { return null }

                // For collapse groups, register accessible children regardless of parent secgroup
                if (r.collapse ?? false) {
                    return r.pages.map((ri, ix2) => {
                        if (!canAccessSecgroup(roleName, ri.secgroup)) { return null }
                        ixm = ixm + 1;
                        return (<Route key={ixm} path={ri.path} element={ri.element}/>);
                    })
                }

                // Non-collapse routes: check secgroup directly
                if (!canAccessSecgroup(roleName, r.secgroup)) { return null }

                if ( r.element && r.element !== "") {
                    ixm = ixm + 1;
                    return (<Route key={ixm}  {...r.routeParam} path={r.path} element={r.element}/>)
                }
                return (null)
            })
        }
            </Routes>
        </React.Fragment>
    )
}



export default (MainRouting)
